import elysiumLogo from "../images/elysium.png";

export const Bio = {
  name: "Sabbir Ahmed",
  roles: [
    "Full Stack Developer",
    "Backend Developer",
    "Problem Solver",
  ],
  description:
    "Looking for a position as a software engineer and enjoy putting new technology into practice. Possess strong skills in programming languages, OOP, data structures, and algorithms.",
  github: "https://github.com/arafatsabbir",

  //https://drive.google.com/file/d/1D0xSOTkAj0daZ_B5lXLSJXGyhgcF_ZmT/view?usp=drive_link
    // "https://drive.google.com/uc?id=1jdnkvlKh83-fb-OUckb9gxcyLvGe5Cd2&export=download",
  resume: "https://drive.google.com/uc?id=1D0xSOTkAj0daZ_B5lXLSJXGyhgcF_ZmT&export=download",
  resumeJP: "",
  linkedin: "https://www.linkedin.com/in/sabbirahmedcse/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: ".Net",
        image: "https://www.vectorlogo.zone/logos/dotnet/dotnet-icon.svg",
      },
      {
        name: "C#",
        image: "https://www.cdnlogo.com/logos/c/27/c.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "SQL Server",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_sql_server/microsoft_sql_server-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Azure Cosmos",
        image: "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Visual Studio",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Visual_Studio_Icon_2019.svg/2060px-Visual_Studio_Icon_2019.svg.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Jira",
        image:
          "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://www.jenkins.io/images/logos/jenkins/jenkins.svg",
      },
      {
        name: "GitHub Copilot",
        image:
          "https://github.githubassets.com/images/modules/logos_page/copilot-mark.svg",
      },
      {
        name: "AWS",
        image:
          "https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/human_resocia.jpg?alt=media&token=27d703f3-b42b-4ebb-b9be-f217e35cc6a6",
    role: "Software Engineer",
    company: "Human Resocia",
    date: "Nov 2024 - Present",
    desc: "Migrated a trade management system from VB.Net to C# and React. Developed screens, created APIs, handled invoice and inventory features, and fixed bugs. Worked in an Agile team with full Japanese communication.",
    skills: [
      "C#",
      ".Net",
      "JavaScript",
      "ReactJS",
      "HTML",
      "CSS",
      "SQL Server",
      "Oracle",
      "Git",
      "Jira",
    ],
    doc: "",
  },
  {
    id: 1,
    img: elysiumLogo,
    role: "Software Engineer",
    company: "Elysium",
    date: "Jan 2026 - Present",
    desc: "Working as frontend React + TypeScript, backend Ruby, C++, C#, and CI/CD. Contributing to their internal 3D/CAD project.",
    skills: [
      "ReactJS",
      "TypeScript",
      "Ruby",
      "C++",
      "C#",
      "Jenkins",
      "GitHub Actions",
      "Python",
      "PowerShell",
      "3D/CAD",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/kaz.png?alt=media&token=5ad8008c-951e-49b6-81cd-d7b01a7d147c",
    role: "Associate Software Engineer",
    company: "Kaz",
    date: "Nov 2021 - Oct 2023",
    desc: "Led the development of diverse applications, from a conference scheduling app with .Net Core, MySQL, Twilio, AWS, ReactJs, Redux, to a US Stock Market analysis app with similar tech stack. Also, contributed to an in-house Leave Management System. Actively involved in training junior software trainees.",
    skills: [
      "C#",
      ".Net",
      "ASP.NET Core",
      "JavaScript",
      "TypeScript",
      "ReactJS",
      "Redux",
      "HTML",
      "CSS",
      "SQL Server",
      "MySQL",
      "AWS",
      "Azure Cosmos",
      "Git",
      "Jira",
    ],
    doc: "",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/present_it.jpg?alt=media&token=90841d38-7609-4dbc-9a79-85be26a050ab",
    role: "Junior Software Engineer",
    company: "Present IT Solutions",
    date: "Aug 2020 - Oct 2021",
    desc: "Built a school management system with ASP.Net Core MVC and SQL Server, and a robust e-Commerce web app using .Net Core 3.1, SQL Server, and ReactJS, serving a retail store with 100k customers.",
    skills: [
      "C#",
      ".Net",
      "ASP.NET Core",
      "JavaScript",
      "TypeScript",
      "ReactJS",
      "Redux",
      "HTML",
      "CSS",
      "SQL Server",
      "MySQL",
      "Git",
      "Trello",
    ],
    doc: "",
  },
];


export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/cou.jpg?alt=media&token=ffcdaa07-4588-4d83-968c-e6b6b23d195f",
    school: "Comilla University, Cumilla",
    date: "Mar 2015 - Feb 2020",
    desc: "I completed bachelor at Comilla University, Cumilla, where I studied Computer Science and Engineering. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Science - BSc, Computer Science and Engineering",
    grade: " CGPA - 3.04",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/csbmc.jpg?alt=media&token=a30c54e8-08f6-4995-aece-99b84a03abe3",
    school: "Cumilla Shikkha Board Govt. Model College, Cumilla",
    date: "Aug 2012 - Apr 2014",
    desc: "I completed my high school and college education at Cumilla Shikkha Board Govt. Model College, Cumilla, where I studied Science.",
    degree: "HSC(XII)",
    grade: " GPA - 5.00",
  },
];

export const projects = [
    {
    id: 0,
    title: "ePortNet",
    date: "Nov 2024 - Present",
    description:
      "Migrated legacy trade system (ePortNet) from VB.Net to C# (.NET Core) and React. Developed UI, REST APIs, handled invoicing and inventory, and fixed bugs. Worked fully in Japanese using SQL Server/Oracle.",
    image:
      "",
    tags: [
      ".Net",
      "C#",
      "JavaScript",
      "React Js",
      "HTML5",
      "CSS3",
      "Oracle",
      "SQL Server",
      "Git",
      "Jira",
    ],
    category: "job",
    github: "",
    webapp: "https://www.fbscorp.com/portnet/lineup",
  },
  {
    id: 1,
    title: "Gateway To Access",
    date: "Feb 2022 - Oct 2023",
    description:
      "Gateway to Access provides Web, Desktop, and Mobile apps for providing interpretation services where users(doctors/lawyers) can take the help of interpreters to communicate with their patients/clients in their native language through remote(audio/video) or face-to-face service in real time or by the pre-scheduled meeting. My major responsibilities are implementing core features, working on multiple server-side projects using C#(.NET 6), configuring and managing various AWS cloud services, designing Database schemas, and developing web UI using React.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/gta.png?alt=media&token=7594c806-b17e-4517-9baf-0da57c6f7866",
    tags: [
      ".Net",
      "C#",
      "TypeScript",
      "React Js",
      "HTML5",
      "CSS3",
      "MySQL",
      "Redux",
      "AWS",
      "Twilio",

    ],
    category: "job",
    github: "",
    webapp: "https://gatewaytoaccess.com/",
  },
  // {
  //   id: 1,
  //   title: "4Kast",
  //   date: "Mar 2022 - Aug 2022",
  //   description:
  //     "Develop a comprehensive US Stock Market analysis and visualization application leveraging the power of .Net Core for backend functionality, MySQL for database management, AWS Lambda for serverless computing, and ReactJs with Redux for a dynamic and responsive frontend.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/forecast.png?alt=media&token=b77ace8d-0679-453f-9ce2-70a459899903",
  //   tags: [
  //     ".Net",
  //     "C#",
  //     "TypeScript",
  //     "React Js",
  //     "HTML5",
  //     "CSS3",
  //     "MySQL",
  //     "Redux",
  //     "AWS",
  //   ],
  //   category: "job",
  //   github: "",
  //   webapp: "https://www.4kastadvisors.com/",
  // },
  {
    id: 2,
    title: "Roostpad",
    date: "Nov 2021 - Jan 2022",
    description:
      "In-house Leave Management System with seamless integration, utilizing .Net Core Web API for robust backend functionality, MySQL for efficient data management, and ReactJs for a user-friendly and responsive frontend, ensuring a streamlined and effective leave management process.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/roostpad.png?alt=media&token=39c8d653-0efb-4fa5-999a-6cec01a0be96",
    tags: [
      ".Net",
      "C#",
      "TypeScript",
      "React Js",
      "HTML5",
      "CSS3",
      "MySQL",
      "Redux",
      "AWS",],
    category: "job",
    github: "",
    webapp: "https://apps.roostpad.com/login",
    // member: [
    //   {
    //     name: "Name",
    //     img: "",
    //     linkedin: "",
    //     github: "",
    //   },
    // ],
  },
  {
    id: 3,
    title: "School Management System",
    date: "Oct 2022 - Jan 2023",
    description:
      "Developed a comprehensive school management system with a focus on student management, teacher management, and exam management, using .Net Core for backend functionality, SQL Server for database management, and ReactJs for a dynamic and responsive frontend.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/lahiri.png?alt=media&token=9da3c0b7-a855-45fb-b0c4-78697987edec",
    tags: [
      ".Net",
      "C#",
      "HTML5",
      "CSS3",
      "TypeScript",
      "React Js",
      "SQL Server",
    ],
    category: "job",
    github: "",
    webapp: "",
  },
  {
    id: 4,
    title: "E-Commerce",
    date: "Sep 2019 - Feb 2020",
    description:
      "Develop a comprehensive E-Commerce application using ASP.NET Core 3.1 MVC and MSSQL, organized within the e-Commerce solution directory. The project incorporates C#, HTML, CSS, and SCSS, utilizing tools such as Visual Studio 2019, MSSQL Server Management Studio, and Bootstrap. The application follows a web-based architecture and is structured with three main components: Libraries (ECommerce.Core, ECommerce.Data), and ECommerce.Web, ensuring modular and maintainable code for efficient development and scalability.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/test-s007.appspot.com/o/ecom.png?alt=media&token=a9ae056d-c3d8-4d7f-923a-e41c2d81ffef",
    tags: [
      ".Net Core MVC",
      "C#", "HTML5",
      "CSS3",
      "Java Script",
      "Bootstrap",
      "SQL Server",
    ],
    category: "university",
    github: "https://github.com/ArafatSabbir/ECommerce",
    webapp: "",
  },
];

